import React from "react";
import { Layout } from "antd";
import logo from "assets/images/eied-logo.svg";

const { Footer: AntFooter } = Layout;

const Footer = () => {
  return <AntFooter className="footer">{`Api Tester `}</AntFooter>;
};

export default Footer;
